import { Dayjs } from 'dayjs';

// The three-rule range-selection model everyone knows from booking.com. Kept in
// its own dependency-free module (only dayjs) so it is the single documented
// source of truth for the picker's click behavior and can be unit-tested
// without pulling in react-day-picker (see dateRangeSelection.test.ts):
//   1. no start yet, or a complete range already exists -> the click starts a
//      fresh selection at that day (end cleared)
//   2. start set, click before it -> move the start earlier, keep picking end
//   3. start set, click on/after it -> that day completes the range as the end
// All inputs are normalised to start-of-day, so `from <= to` always holds on a
// completed range and an inverted range can never be produced here.
export function nextRange(
    clicked: Dayjs,
    from: Dayjs | null,
    to: Dayjs | null,
): { from: Dayjs, to: Dayjs | null } {
    const day = clicked.startOf('day');
    const curFrom = from ? from.startOf('day') : null;
    const curTo = to ? to.startOf('day') : null;

    if (!curFrom || curTo || day.isBefore(curFrom)) {
        return { from: day, to: null };
    }
    return { from: curFrom, to: day };
}
